export const REASSIGNMENT_STATUS = {
  INITIATED: 'initiated',
  APPROVED: 'approved',
  DENIED: 'denied',
  ASSIGNED_TO_CC: 'assigned_to_cc',
  CANCELLED: 'cancelled',
} as const
